import * as React from 'react';
import styled from 'styled-components';

import { Line } from '../ui/divider/Line';
import { animated, useSpring } from 'react-spring';

export const StatusOverviewStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    color: ${({ theme }) => theme.colors.primary};
    
    @media all and (max-width: 450px) {
      margin-bottom: 0.5em;
    }
  }

  p {
    font-size: 25px;
    color: ${({ theme }) => theme.colors.white};
    text-align: center;

    @media all and (max-width: 450px) {
      margin: 0.5em auto;
      font-size:22px;
    }
  }
`;

export const StatusItem: React.FC<{ count: number; description: string }> = ({
  count = 0,
  description,
}) => {
  const props = useSpring({
    delay: 800,
    val: count ? count : 0,
    from: { val: 0 },
  });
  return (
    <StatusOverviewStyle>
      <animated.h1>{props.val.to((val) => Math.floor(val))}</animated.h1>
      <Line />
      <p>{description}</p>
    </StatusOverviewStyle>
  );
};
